import { Injectable } from "@angular/core";
import { BootConstants } from "../boot.constants";
import { map } from 'rxjs/operators';
import { TokenHttp } from "../services/tokenhttp.service";
import { Observable } from "rxjs";
import { toJSONDateTime, toJSONDate } from "../helpers/date";
import { convertQueryStringInput, IDataQueryString, setQueryStringAttachments } from "../helpers/querystring";

@Injectable()
export class BaseRepository {

  constructor(private tokenHttp: TokenHttp) { }

  mapGet(url, queryStrings: IDataQueryString[] | Object = []): Observable<any> {
    var qStringArr = convertQueryStringInput(queryStrings);

    return this.tokenHttp.get(BootConstants.apiServiceEndpoint + url + setQueryStringAttachments(qStringArr))
      .pipe(map((res: Response) => res.json()));
  }

  mapPost(url, body?: any, queryStrings: IDataQueryString[] | Object = []): Observable<any> {

    var qStringArr = convertQueryStringInput(queryStrings);

    return this.tokenHttp.post(BootConstants.apiServiceEndpoint + url + setQueryStringAttachments(qStringArr), body)
      .pipe(map((res: Response) => res.json()));
  }

  mapPut(url, body?: any, queryStrings: IDataQueryString[] | Object = []): Observable<any> {

    var qStringArr = convertQueryStringInput(queryStrings);

    return this.tokenHttp.put(BootConstants.apiServiceEndpoint + url + setQueryStringAttachments(qStringArr), body)
      .pipe(map((res: Response) => { try { return res.json() } catch { return {} } }));
  }

  mapDelete(url, queryStrings: IDataQueryString[] | Object = []): Observable<any> {

    var qStringArr = convertQueryStringInput(queryStrings);

    return this.tokenHttp.delete(BootConstants.apiServiceEndpoint + url + setQueryStringAttachments(qStringArr))
      .pipe(map((res: Response) => { try { return res.json() } catch { return {} } }));
  }

}


